import React, { useEffect, useState } from 'react';
import axios from 'axios';
import qs from 'qs';
import { rescueHtml, deleteOrganisme } from './Tools';
import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import { ReactComponent as Bin } from '../Img/icon-bin.svg';
import Dialog from "./Dialog";

const DeleteOrganisme = (props) =>
{
    const [organismes, setOrganismes] = useState([]);
    const [organisme, setOrganisme] = useState();
    const [searchText, setSearchText] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    const red = '#E33636';
    const purple = '#6571FE';

    // Filtrer les organismes en fonction du texte de recherche
    const organismesFiltres = searchText === ''
        ? organismes
        : organismes.filter(org => org.nom.toLowerCase().includes(searchText.toLowerCase()));
    
    const [dialogModalVisible, setDialogModalVisible] = useState(false);
    
    function callbackDialog(ret) {
        if (ret === true) {
            suppress();
        }
    }

    useEffect(() => {
        if (props.organismes && props.organismes.length > 0) {
            var tmp = [];
            for (let i = 0; i < props.organismes.length; i++) {
                tmp[i] = {
                    id: props.organismes[i].id,
                    nom: rescueHtml(props.organismes[i].nom)
                }
            }
            setOrganismes(tmp);
            setIsLoading(false);
        }
    }, [props.organismes])
        
    function suppress()
    {
        if (organisme !== undefined && organisme !== '')
        {
            deleteOrganisme(organisme)
            NotificationManager.success('Organisme et Budgets supprimés', '', 700);
            setTimeout(() => window.location = window.location.href, 900);
        }
    }

	return (
        <div className='shadow-xl' style={{textAlign: 'center',  borderRadius: 3, padding: 5, margin: 1, backgroundColor: 'white'}}>

            <NotificationContainer />

            <Dialog
                setModalVisible={setDialogModalVisible}
                modalVisible={dialogModalVisible}
                callbackDialog={callbackDialog}
                message={"Confirmez la suppression :"}
            />

            <p style={{color: purple, fontSize: 20}}>Supprimer un organisme :</p>
            {isLoading ? (
                <div style={{margin: 10, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 150}}>
                    <div className='spinner' style={{
                        border: '4px solid #f3f3f3',
                        borderTop: '4px solid #6571FE',
                        borderRadius: '50%',
                        width: '40px',
                        height: '40px',
                        animation: 'spin 1s linear infinite'
                    }}>
                        <style>{`
                            @keyframes spin {
                                0% { transform: rotate(0deg); }
                                100% { transform: rotate(360deg); }
                            }
                        `}</style>
                    </div>
                </div>
            ) : (
            <div style={{textAlign: 'center'}}>
                <div style={{margin: 10}}>
                    <div style={{margin: 10}}>
                        <label style={{display: 'block', marginBottom: 5, fontWeight: 'bold'}}>Recherche par intitulé :</label>
                        <input
                            type="text"
                            style={{padding: 5, width: '90%', boxSizing: 'border-box'}}
                            className='shadow-md'
                            placeholder="Entrez le nom de l'organisme..."
                            value={searchText}
                            onChange={(e) => {
                                setSearchText(e.target.value);
                                setOrganisme('');
                            }}
                        />
                    </div>

                    <div style={{margin: 10}}>
                        <select
                        className='shadow-md'
                        style={{width: '90%', padding: 5, boxSizing: 'border-box', textAlign: 'center'}}
                        onChange={(e) => {
                            setOrganisme(e.target.value)
                        }}
                        >
                            <option value="">...</option>
                            {organismesFiltres.map((organisme) => 
                            <option key={organisme['id']} value={organisme['id']}>{organisme['nom']}</option>
                            )}
                        </select>
                    </div>

                    <div style={{margin: 10, alignItems: 'center', justifyContent: 'center', display: 'flex'}}>
                        <button
                            className='shadow-md rounded-md'
                            style={{backgroundColor: red, color: 'white', fontSize: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', paddingLeft: 10, paddingRight: 10}}
                            onClick={() => {
                                if (organisme !== undefined && organisme !== '') {
                                    setDialogModalVisible(true)
                                }
                            }}
                        >
                            <Bin width="12"/>
                            <p style={{marginLeft: 5}}>Supprimer</p>
                        </button>
                    </div>
                </div>
            </div>
            )}
        </div>
	);
}

export default DeleteOrganisme;
